import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	archived: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	archived: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.component.archived',
		defaultMessage: 'Archived',
		description: 'Text for lozenge tag displayed when a component is in archived state.',
	},
});
export default messages;
